import { jsx as _jsx } from "react/jsx-runtime";
import { Types, Variants } from "./constants";
import { StyledInformativeTag } from "./InformativeTag.style";
const InformativeTag = ({ children, variant = Variants.filled, type = Types.neutral, ...props }) => (_jsx(StyledInformativeTag, { variant: variant, type: type, ...props, children: children }));
export default InformativeTag;
//# sourceMappingURL=InformativeTag.js.map